import get from 'lodash/get';

const getDayOfWeek = (day: string) =>
  get(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], day, '');

export default getDayOfWeek;
